import { observer } from "mobx-react"
import {
  DocumentTemplate,
  Page,
  Header,
  useStore,
  Footer,
  PureLogo,
} from "@features/common"
import { RouterLink } from "@lib/routing"
import { scrollToTop } from "@lib/scroll"
import { IconHamburger } from "@lib/icons"
import { ContactUsLogo } from "@features/contact-us"

import { ContactUsElement } from "../contact-us-element"

export const ContactUsPage = observer(function ContactUsPage() {
  const {
    GlobalModel: { openMenu },
    ContactUsModel: { title, elements, getTextByKey },
  } = useStore()

  const metaTitle = getTextByKey("metaTitle") || title
  const description = getTextByKey("metaDescription")
  const seoH1 = getTextByKey("seoH1.title")

  return (
    <Page
      meta={{
        title,
        metaTitle,
        description,
      }}
      seoH1={seoH1}
      header={
        <Header
          theme="dark"
          logo={
            <RouterLink
              uri="/contact-us"
              onClick={() => scrollToTop()}
              data-test-id="header__pure_logo"
              aria-label="root"
              className="mt-4 mb-3 tablet-m:mt-[20px] tablet-m:mb-[18px]"
            >
              <div className="shrink-0 flex items-stretch h-4 tablet-m:h-7">
                <PureLogo className="shrink-0 block h-full w-auto tablet:h-full text-white pr-2 tablet-m:pr-4" />
                <ContactUsLogo />
              </div>
            </RouterLink>
          }
          languageSwitcher={null}
          navigationOpener={
            <button
              onClick={openMenu}
              data-test-id="header__menu_button"
              aria-label="menu"
            >
              <IconHamburger className="w-8 h-8 text-white" />
            </button>
          }
        />
      }
      footer={<Footer chinese />}
    >
      <div className="container pb-15 laptop:pt-8 laptop:pb-20">
        <DocumentTemplate>
          <section className="w-full">
            <div className="container pt-4">
              <h1
                className="text-[24px] tablet:text-[34px] leading-9 uppercase font-serif tablet:mb-9"
                dangerouslySetInnerHTML={{
                  __html: title,
                }}
              />
            </div>

            {elements.map((element, index) => {
              return (
                <ContactUsElement
                  key={index}
                  background={element.background}
                  content={element.Content}
                />
              )
            })}
          </section>
        </DocumentTemplate>
      </div>
    </Page>
  )
})
